module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_rank_no6-1b1feaf89ada10b14f7db237c826baea.png";